import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ATTRIBUTE_SKELETON_CLASS_NAME = 'AttributeSkeleton';

export const ATTRIBUTE_SKELETON_CLASS_SLOTS: Partial<
	keyof AttributeSkeletonClasses
>[] = ['root', 'readOnlyText', 'skeletonItem'];

export type AttributeSkeletonClassSlot =
	(typeof ATTRIBUTE_SKELETON_CLASS_SLOTS)[number];

export interface AttributeSkeletonClasses {
	root: string;
	readOnlyText: string;
	skeletonItem: string;

	inputArea: string;
	preDecorator: string;
	postDecorator: string;
	readOnly: string;
	readOnlyTextTitle: string;
	readOnlyTextValue: string;
}

export type AttributeSkeletonClassKey = keyof AttributeSkeletonClasses;

export const getAttributeSkeletonUtilityClass = (slot: string) =>
	generateUtilityClass(ATTRIBUTE_SKELETON_CLASS_NAME, slot);

export const attributeSkeletonClasses = generateUtilityClasses<
	keyof AttributeSkeletonClasses
>(ATTRIBUTE_SKELETON_CLASS_NAME, [
	'root',
	'inputArea',
	'postDecorator',
	'preDecorator',
	'readOnly',
	'readOnlyText',
	'readOnlyTextTitle',
	'readOnlyTextValue',
	'skeletonItem',
]);

export default attributeSkeletonClasses;
